// extracted by mini-css-extract-plugin
export default {"BreakpointFromMedium":"(min-width: 640px)","getInTouchCTA":"G14a845","heading":"G87114b G519ebe","text":"Gf2aa2d"};